import React from 'react';
import { useSelector } from 'react-redux';
import './CalendarSyncDisabled.scss';
import Progress from '../shared/Progress';

export const CalendarSyncDisabled = () => {
  const isLoading = useSelector((state) => state.app.isLoading);
  return (
    <div className={'calendarSyncDisabled-container'}>
      { isLoading ? <Progress /> : <>
        <div className='calendarSyncDisabled-content'>
          <p className='calendarSyncDisabled-heading'>Calendar for Docrio Email <br/>is not enabled.</p>
          <p className='calendarSyncDisabled-paragraph'>Contact your Admin to enable Calendar for Docrio Email.</p>
        </div>
      </>
      }
    </div>
  );
};
